module.exports = __webpack_public_path__ + "img/block01_h5.d59d0909.webp";